module.exports = __webpack_public_path__ + "assets/ef06a00bb97c69cd0f0d8fd003285c8f.mp3";